var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-msg-container"
  }, [_c('div', {
    staticClass: "content_wrap"
  }, [_c('div', {
    staticClass: "son-page"
  }), _vm._v(" "), _c('div', {
    staticClass: "menu_wrap"
  }, [_c('div', {
    staticClass: "ticket_wrap"
  }, [_c('div', {
    class: [{
      'act-item': _vm.activeIndex == 0
    }, 'media_font_size_50'],
    on: {
      "click": function($event) {
        _vm.activeIndex = 0
      }
    }
  }, [_vm._v("在线售票")]), _vm._v(" "), _c('div', {
    class: [{
      'act-item': _vm.activeIndex == 1
    }, 'media_font_size_50'],
    on: {
      "click": function($event) {
        _vm.activeIndex = 1
      }
    }
  }, [_vm._v("购票须知")])]), _vm._v(" "), _c('div', {
    staticClass: "right_wrap",
    style: ({
      'fontSize': '14px'
    })
  }, [_vm._v("\n        当前位置：\n        "), _c('el-breadcrumb', {
    attrs: {
      "separator-class": "el-icon-arrow-right"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("新闻中心")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.activeIndex == 0 ? '在线售票' : '购票须知'))])], 1)], 1)]), _vm._v(" "), (_vm.activeIndex == 0) ? _c('div', {
    staticClass: "online-sell"
  }, [_c('h2', [_vm._v("暂未有相关内容")])]) : _vm._e(), _vm._v(" "), (_vm.activeIndex == 1) ? _c('div', {
    staticClass: "buy_notice"
  }, [_c('h1', {
    staticClass: "media_font_size_70",
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_vm._v("购票须知标题")]), _vm._v(" "), _c('span', {
    staticClass: "media_font_size_50"
  }, [_vm._v("购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容购票须知内容")])]) : _vm._e()]), _vm._v(" "), _c('page-bottom')], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b4e9ba0","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/buyTicket/index.vue
// module id = null
// module chunks = 